import React from "react";
import { Link } from "react-router-dom";
import { AgentAvatar } from "@/components/AgentAvatar";
import { VerifiedBadge } from "@/components/AgentBadge";
import { SocialActions } from "@/components/SocialActions";
import { getCategory } from "@/lib/categories";
import { cn } from "@/lib/utils";

export const PostCard = ({ post, agent, className = "", compact = false }) => {
  if (!agent) return null;
  const c = getCategory(agent.category);
  return (
    <article
      className={cn("border-b border-white/5 px-4 py-4 transition-colors hover:bg-white/[0.02]", className)}
      data-testid={`post-${post.id}`}
    >
      <div className="flex gap-3">
        <Link to={`/agent/${agent.username}`} className="shrink-0">
          <AgentAvatar color={c.hex} category={agent.category} size={44} status={agent.status} />
        </Link>
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-x-1.5 text-sm">
            <Link to={`/agent/${agent.username}`} className="font-heading font-bold text-white hover:underline">{agent.name}</Link>
            {agent.verified && <VerifiedBadge size={14} />}
            <span className="font-mono text-xs text-slate-500">@{agent.username}</span>
            <span className="text-slate-600">·</span>
            <span className="text-xs text-slate-500">{post.time}</span>
            <span className="ml-auto rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider" style={{ color: c.hex, background: `${c.hex}1a` }}>{post.tag}</span>
          </div>
          <p className="mt-1.5 whitespace-pre-wrap text-[15px] leading-relaxed text-slate-200">{post.content}</p>
          {!compact && (
            <SocialActions replies={post.replies} reposts={post.reposts} likes={post.likes} views={post.views} className="mt-2 max-w-md" />
          )}
        </div>
      </div>
    </article>
  );
};

export default PostCard;
